export const projectGeneralFields = {
    ID: 'id',
    PROJECT_STATUS_ID: 'project_status_id',
    PROJECT_TYPE_ID: 'project_type_id',
    PROJECT_SUBTYPE_ID: 'project_sub_type_id',
    PROJECT_END_DATE: 'project_end_date',
    PROJECT_RECEIPT_DATE: 'project_receipt_date',
    CONTRACT_NO: 'contract_no',
    CONTRACT_DATE: 'contract_date',
    OWNER_ID: 'owner_id',
    COUNTRY_ID: 'country_id',
    COUNTY_ID: 'county_id',
    CITY_ID: 'city_id',
    WIDER_AREA_ID: 'wider_area_id',
    QUARTER_ID: 'quarter_id',
    ISLAND_ID: 'island_id',
    STREET: 'street',
    STREET_NUMBER: 'street_number',
    STREET_SYNC: 'street_sync',
    PROJECT_ENERGY_EFFICIENCY_ID: 'project_energy_efficiency_id',
    PROJECT_WEB_SYNC: 'project_web_sync',
    AGENT_ID: 'agent_id',
    PROJECT_EXTERNAL_URL: 'project_external_url',
}

export const projectDescriptionFields = {
    PROJECT_TITLE: 'project_title',
    PROJECT_DESCRIPTION: 'project_description',
    PROJECT_OFFER_DESCRIPTION: 'project_offer_description',
}

export const projectDetailSearchFields = {
    ID: 'id',
    INTERNAL_APP_ID: 'internalAppId',
    PROJECT_TITLE: 'projectTitle',
    CITY: 'city',
    PROJECT_TYPE: 'projectType',
    PROJECT_STATUS: 'projectStatus',
    AGENT: 'agent',
    PROJECT_RECEIPT_DATE_FROM: 'projectReceiptDateFrom',
    PROJECT_RECEIPT_DATE_TO: 'projectReceiptDateTo',
}
